/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import { getApiUrl } from "@/utils/baseUrl";

export interface SelfSample {
  t: number;
  cpu: number;
  rss: number;
  heap: number;
  goroutines: number;
}

/** Nyrvex process's own resource usage (GET /api/system/self). */
export interface SelfUsage {
  version: string;
  pid: number;
  startedAt: string;
  uptimeSeconds: number;
  cpus: number;
  goroutines: number;
  heapBytes: number;
  sysBytes: number;
  gcCycles: number;
  cpuPercent?: number;
  rssBytes?: number;
  threads?: number;
  openFiles?: number;
  dbBytes?: number;
  diskTotal?: number;
  diskFree?: number;
  diskPercent?: number;
  backupCount?: number;
  backupAt?: string;
  samples: SelfSample[];
}

export async function getSelfUsage(): Promise<SelfUsage> {
  const response = await fetch(getApiUrl("/system/self"), { credentials: "include" });
  if (!response.ok) throw new Error("Failed to fetch service usage");
  return response.json();
}
